import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import WhyChooseUs from './components/WhyChooseUs';
import MilitaryDiscount from './components/MilitaryDiscount';
import Portfolio from './components/Portfolio';
import Contact from './components/Contact';
import Footer from './components/Footer';
import SeoJsonLd from './components/SeoJsonLd';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-black">
      <SeoJsonLd />
      <Navbar />
      <Hero />
      <About />
      <Services />
      <WhyChooseUs />
      <MilitaryDiscount />
      <Contact />
      <Portfolio />
      <Footer />
    </div>
  );
}
